<template>
    <div class="cst-survey-answer cst-survey-answer-percent">
        <div class="cst-survey-answer-percent-desktop">
            <div class="cst-survey-answer-percent-legend-container">
                <div class="legend-primer legend-primer-negative">{{ $t('legendPrimerNegative') }}</div>
                <div class="legend-primer legend-primer-positive">{{ $t('legendPrimerPositive') }}</div>
            </div>
            <ul>
                <li @mouseover="currentlyHovered = entry" @mouseleave="currentlyHovered = false" :key="entry.percent" v-for="(entry,index) in categories" v-bind:class="{ selected: isPercentageSelected(entry.percent)}" v-on:click="answer_question(entry.percent)">
                    {{ entry.percent }}{{ percentageSign(index,categories)}}
                </li>
            </ul>
        </div>
        <div class="cst-survey-answer-percent-mobile">
            <app-scale-percentage-mobile v-bind:answer_question="answer_question" v-bind:isPercentageSelected="isPercentageSelected"></app-scale-percentage-mobile>
        </div>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import AppScalePercentageMobile from './AppScalePercentageMobile'

    export default {
      props: ['question'],
      data: function () {
        return {
          currentlyHovered: false,
          categories: (function () {
            var percentage_categories = []
            var percentages = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
            for (var index in percentages) {
              var percentage = percentages[index]
              percentage_categories.push({
                percent: percentage,
                description: 'percent' + percentage + 'Description'
              })
            }
            return percentage_categories
          }())
        }
      },
      methods: {
        answer_question: function (percent) {
          eventHub.$emit('answer-question', { 'answerScore': percent, 'answerValue': percent, 'questionId': this.question.id })
        },
        getCategoryByPercentage: function (percent) {
          for (var index in this.categories) {
            var category = this.categories[index]
            if (category.percent === percent) {
              return category
            }
          }
          return false
        },
        percentageSign: function (index, list) {
          if (index === 0 || index === list.length - 1) {
            return '%'
          }
          return ''
        },
        isPercentageSelected: function (percent) {
          return !!this.question.answer && this.question.answer.answerScore * 1 === percent * 1
        }
      },
      computed: {
        currentlyHighlightedCategoryDescription: function () {
          if (this.currentlyHovered) {
            return this.$t(this.currentlyHovered.description)
          } else if (this.question.answer.answerValue !== '') {
            return this.$t(this.getCategoryByPercentage(this.question.answer.answerValue).description)
          }
          return ''
        }
      },
      components: {
        AppScalePercentageMobile
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-answer ul, .cst-survey-answer li {
        margin: 0;
        padding: 0;
        list-style-type: none;
        cursor: pointer;
    }
    .cst-survey-answer ul {
        display: flex;
        //flex-direction: row-reverse;
        justify-content: center;
        border-left: 1px solid #ccc;
    }
    .cst-survey-answer li {
        width: 10%;
        border: 1px solid #ccc;
        border-left: none;
        flex-grow: 1;
        padding: 1em 0.1em;
        text-align: center;
    }
    .selected {
        background-color: @item-active-color;
    }
    li:hover {
        background-color: @item-active-color;
    }
    li:active {
        background-color: @item-active-color;
    }

    .currently-highlighted {
        text-align: center;
        margin: 0.3em;
    }
    .cst-survey-answer-percent-legend-container {
        display: none;
        justify-content: space-between;
    } 
    .legend-primer {
        font-size: 80%;
    }
    @media (max-width: 850px) {
        .cst-survey-answer ul {
            flex-direction: column-reverse;
        }
        .cst-survey-answer li {
            width: 100%;
        }
        .cst-survey-answer-percent-legend-container {
            display: none;
        }
        .cst-survey-answer-percent-mobile {
            display: block;
            width: 90%;
            margin: 0 auto;
        }
        .cst-survey-answer-percent-desktop {
            display: none;
        }        
    }   
    @media (min-width: 850px) {
        .cst-survey-answer-percent-mobile {
            display: none;
        }
        .cst-survey-answer-percent-desktop {
            display: block;
        }
    }
      

</style>


// WEBPACK FOOTER //
// src/components/CardAnswerPercent.vue